import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import merchantActions from 'actions/merchants/actions'
import LayoutView from 'components/shared/layout/view'
import Navigation from './navigation'
import Header from './header'
import VenueDropdown from './venue-dropdown'
import componentObj from './dataset'
import SwitchableContent from './switcahble-content'

const Bookings = ({ id, venueList, fetchVenues, loading }) => {
  useEffect(() => { fetchVenues(id) }, [])
  const [selectedComponent, setSelectedComponent] = useState('leads')
  const [selectedVenue, setSelectedVenue] = useState('')
  const RenderComponent = componentObj.find(({ value }) => value === selectedComponent).component

  return (
    <LayoutView theme="grey" customClass="" loading={loading}>
      <SwitchableContent>
        {handleSwitchContent => (
          <div className="bg-white md:my-10 w-full md:w-11/12 shadow-md md:rounded-lg m-auto">
            <Navigation selected={selectedComponent} onClick={value => setSelectedComponent(value)} />
            <div className="my-5">
              <Header selected={selectedComponent}>
                <VenueDropdown
                  selected={selectedVenue}
                  options={venueList}
                  onChange={value => setSelectedVenue(value)}
                />
              </Header>
              <RenderComponent selectedVenue={selectedVenue} handleSwitchContent={handleSwitchContent} />
            </div>
          </div>
        )}
      </SwitchableContent>
    </LayoutView>
  )
}

Bookings.propTypes = {
  id: PropTypes.string.isRequired,
  fetchVenues: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  venueList: PropTypes.array,
}

const mapStateToProps = ({ auth, bookings, merchant }) => ({
  id: auth.user.id,
  loading: bookings.fetching,
  venueList: merchant.venueList,
})

const mapDispatchToProps = {
  fetchVenues: merchantActions.fetchMerchantVenues,
}

export default connect(mapStateToProps, mapDispatchToProps)(Bookings)
